{
  "sidebar": {
    "data": {
      "title": "Daten"
    },
    "insights": {
      "title": "Insights"
    },
    "instances_caches": {
      "title": "Caches"
    },
    "dependencies": {
      "title": "Dependencies"
    },
    "jvm": {
      "title": "JVM"
    },
    "logging": {
      "title": "Logging"
    },
    "security": {
      "title": "Sicherheit"
    },
    "web": {
      "title": "Web"
    },
    "custom-link": {
      "title": "Links"
    }
  }
}
